import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogWamFaqComponent } from '../dialog-wam-faq/dialog-wam-faq.component';

@Component({
  selector: 'cigna-login-message-v2',
  templateUrl: './login-message-v2.component.html',
  styleUrl: './login-message-v2.component.scss',
})
export class LoginMessageV2Component {
  @Input() params?: Params;

  constructor(public dialog: MatDialog) {}

  get status(): string {
    return this.params && this.params.status
      ? this.params.status.toLowerCase()
      : '';
  }

  get dateTimeUntil(): string {
    return this.params && this.params.expireTs
      ? new Date(Number(this.params.expireTs)).toLocaleString()
      : '';
  }

  openWamFaqModal(hasWam: boolean) {
    this.dialog.open(DialogWamFaqComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        hasWam,
      },
    });
  }
}
